import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { DefaultImageSizePatterns } from './PatternedImageRow.constants';
import { ImageSizePatternPropType } from './PatternedImageRow.types';
import { getImageId, getContainerStyle, getContainerClassName, getImagePattern } from './PatternedImageRow.utils';
import Image from '../../../../atoms/Image';
import { ImagePropType } from '../../../../services/proptypes';
import { createComponent } from '../../../foundation/services/components';
import { ComponentPropType } from '../../../foundation/types/component';
import './PatternedImageRow.css';
var defaultProps = {
  imageSizePatterns: DefaultImageSizePatterns,
  containerAs: 'div'
};
export default function PatternedImageRow(_ref) {
  var images = _ref.images,
    imageSizePatterns = _ref.imageSizePatterns,
    containerAs = _ref.containerAs;
  if (_isEmpty(images)) {
    return null;
  }
  return images.map(function (image) {
    var imageId = getImageId(image);
    var targetPattern = getImagePattern(image, images, imageSizePatterns);
    var containerStyle = getContainerStyle(targetPattern);
    var containerClassName = getContainerClassName(targetPattern);
    var imageComponent = /*#__PURE__*/React.createElement(Image, {
      src: image,
      style: {
        height: '100%',
        width: '100%'
      }
    });
    var containerProps = {
      children: imageComponent,
      className: containerClassName,
      style: containerStyle,
      key: imageId
    };
    return createComponent(containerAs, containerProps);
  });
}
PatternedImageRow.defaultProps = defaultProps;